<template>
  <div class="accordion py-3" id="apiAccordionChild">
    <div v-for="faq in FAQ">
      <div :id="faq.id">
        <h2 class="mb-0">
          <div class="d-inline-flex align-items-center btn text-left text-blackish" data-toggle="collapse"
               :data-target="'#' + faq.target"
               aria-expanded="true"
               :aria-controls="faq.target"
               @click="checkExpand(faq.id)">
            <i :class="{'fa-caret-right': !faq.type, 'fa-caret-down': faq.type}"
               class="fa text-theme text-decoration-none" aria-hidden="true" style="width: 10px;"></i>
            <div class="pl-2 font-xs-14">
              {{ faq.ques }}
            </div>
          </div>
        </h2>
      </div>
      <div :id="faq.target" class="collapse" :aria-labelledby="faq.id" data-parent="#apiAccordionChild">
        <div class="card-body font-xs-13 font-weight-light-xs text-blackish pl-sm-5">
          {{ faq.ans }}
          <div class="py-sm-2 py-3">
            <a v-if="faq.url" target="_blank" :href="faq.url" class="link-text text-decoration-underline"><u>See Full Answer</u></a>
          </div>
        </div>
      </div>
    </div>
    <div class="py-sm-3 py-3 px-3">
      <a target="_blank" class="link-text text-decoration-underline"
         href="https://support.qrbatch.io/hc/en-us">
        SEE ALL FAQs
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      FAQ: [
        {
          ques: 'I have signed up for an account. How do I create a batch of QR Codes?',
          ans: 'Now that you’ve signed up for a QR Batch account, you can start creating a batch of QR Codes. Go to the Create Batch section and follow step-by-step instructions. Note that for bulk generation of QR Codes you’ll need to provide QR Code data, either by entering manually or uploaded via CSV/XLS/XLSX file in a specific format. Simply add the data, add design to QR Code, make one-time payment, and export the QR Codes either as images (in ZIP folder) or as QR Code Labels (in printable PDFs or DXFs)',
          id: 'headingOne',
          target: 'collapseOne',
          url: 'https://support.qrbatch.io/hc/en-us/articles/35880198464025-About-QR-Batch-',
          type: false
        },
        {
          ques: 'How much time does it take to process a QR Code batch?',
          ans: 'Time required to process a batch depends on the number of QR Codes required—either as images or labels. Total time can vary between a few minutes to 8 hours depending on the size of the batch. You can check the status of your batch via the My Batches section. Typically, QR Code labels will take slightly more time than QR Code images. If a batch has not processed within 8 hours or if you feel the batch should have been completed, please reach out to our support team via chat, email, or phone call. ',
          id: 'headingTwo',
          target: 'collapseTwo',
          url: 'https://support.qrbatch.io/hc/en-us/articles/36095494276633-How-to-Use-QR-Batch-',
          type: false
        },
        {
          ques: 'What happens if my batch is not processed?',
          ans: 'This can happen in two cases. First, if there is an error in the uploaded CSV/Excel file. In this case, we recommend you to use the sample CSV/Excel templates to add data. Second, due to a technical issue. In this case, reach to us and we will share the QR Code batch over email or issue a 100% refund.',
          id: 'headingThird',
          target: 'collapseThird',
          url: false,
          type: false
        },
        {
          ques: 'How long will my QR Codes work?',
          ans: 'Forever. The QR Codes generated via QR Batch are Static in nature. These codes are permanent as data is encoded directly into the QR Code. The QR Code is not linked to the QR Batch service in any way and will work forever.',
          id: 'headingFourth',
          target: 'collapseFourth',
          url: 'https://support.qrbatch.io/hc/en-us/articles/36095494276633-How-to-Use-QR-Batch-',
          type: false
        }
      ]
    }
  },
  methods: {

    /** Method used to expand accordions of Faq tab */
    checkExpand(type) {
      for (let i = 0; i < this.FAQ.length; i++) {
        if (this.FAQ[i].id === type) {
          this.FAQ[i].type = !this.FAQ[i].type;
        } else {
          this.FAQ[i].type = false;
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/_variable.scss";
a:hover {
  color: $theme-text-color !important;
}
</style>
